import React from "react";

const ListSkeleton = ({ count = 6, columns = 3 }) => {
  const cards = Array.from({ length: count });

  return (
    <div
      className={`flex flex-col gap-2`}
    >
      {cards.map((_, index) => (
        <div
          key={index}
          className="animate-pulse p-4 bg-gray-100 rounded-lg shadow-sm"
        >
          <div className="h-4 w-20 bg-gray-300 rounded-md mb-2"></div>
          <div className="h-4 bg-gray-300 rounded-md mb-2"></div>
          <div className="h-4 bg-gray-200 rounded-md"></div>
        </div>
      ))}
    </div>
  );
};

export default ListSkeleton;